/*
 * Copyright (C) 2025 SimpliCity Digital Inc - All Rights Reserved
 */

import { NavLink } from "react-router-dom";
import { ReactComponent as KitimatLogo } from "cms/assets/images/kitimat-logo-horizontal.svg";
import { HeaderMenu } from "./header-menu";
import { MobileMenu } from "./mobile-menu";

const HeaderNavBar = () => {

    return (
        <div className="header-nav-bar">
            <div className="header-nav-bar-container">
                <NavLink to="/" className="header-logo">
                    <KitimatLogo alt="kitimat-logo" />
                </NavLink>
                <HeaderMenu />
                <MobileMenu />
            </div>
        </div>
    );
};

export { HeaderNavBar };
